// removed by extract-text-webpack-plugin
module.exports = {"container":"___Login__container___1xv4l"};


//////////////////
// WEBPACK FOOTER
// ./src/app/containers/Login/Login.less
// module id = 1025
// module chunks = 0